
      <div  
        class="btn-group dropdown-group" 
        dropdown #cityDrop="bs-dropdown" [autoClose]="false">
          <form-city-input [form]="form" (newValue)="newValue.next(null)" (inputValue)="syncroCityName($event)" [cityName]="setCityName" class="inline-block inputShorted" ></form-city-input>

          <ul [hidden]=" !isShowCitiesList || ! isCloseCitiesPresent() " id="dropdown-triggers-manual" *dropdownMenu class="cities-dropdown-menu"
              role="menu" aria-labelledby="button-triggers-manual" >
            <div role="menuitem" *ngFor="let city of closeCities" >
              <button type="button" id="{{city.CITY_ID}}" class="dropdown-item" 
              (click)="selectCity( $event.target.textContent, city.CITY_ID ); cityDrop.hide() ; isShowCitiesList = false "  >
                {{ city.SHORTCITYTYPE_UA }} {{ city.CITY_UA }}, {{ city.DISTRICT_UA }} р-н, {{ city.REGION_UA  }} обл.
              </button>
            </div>
            
          </ul>

          <button type="button" [disabled]="! isCloseCitiesPresent() "
            [ngClass]="dropdownButtonClass" 
            class="btn btn-white dropdown-toggle-split dropButton " 
            (click)="isShowCitiesList = ! isShowCitiesList "
            formnovalidate="formnovalidate"  >
              <i class="fas fa-caret-down"></i>
          </button>


      </div>

     
  